import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {FieldDescription} from './field-description';
import {DateAdapter, NativeDateAdapter} from '@angular/material/core';
import { NgFor, NgIf } from '@angular/common';
import { MatFormField, MatLabel, MatHint, MatSuffix } from '@angular/material/form-field';
import { MatFormFieldFix } from '../mat-form-field/mat-form-field-fix';
import { MatInput } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatDatepickerInput, MatDatepickerToggle, MatDatepicker } from '@angular/material/datepicker';
import { MatCheckbox } from '@angular/material/checkbox';

@Component({
    selector: 'app-dynamic-form',
    template: `
    <div class="form-container" *ngFor="let formField of formModelDescription">
      <mat-form-field appearance="outline" class="regular-form-field" *ngIf="formField.fieldType === 'text'">
        <mat-label>
          {{formField.fieldLabel}}
        </mat-label>
        <input matInput type="text" [id]="formField.fieldName" name="{{formField.fieldName}}"
               [(ngModel)]="formModel[formField.fieldName]" (ngModelChange)="modelChanged($event)">
      </mat-form-field>

      <mat-form-field appearance="outline" class="regular-form-field" *ngIf="formField.fieldType === 'number'">
        <mat-label>
          {{formField.fieldLabel}}
        </mat-label>
        <input matInput type="number" class="form-control" [id]="formField.fieldName" name="{{formField.fieldName}}"
               [(ngModel)]="formModel[formField.fieldName]" (ngModelChange)="modelChanged($event)">
      </mat-form-field>

      <mat-form-field appearance="outline" class="regular-form-field" *ngIf="formField.fieldType === 'textarea'">
        <mat-label>
          {{formField.fieldLabel}}
        </mat-label>
        <textarea matInput rows="3" [id]="formField.fieldName" name="{{formField.fieldName}}"
                  [(ngModel)]="formModel[formField.fieldName]" (ngModelChange)="modelChanged($event)"></textarea>
      </mat-form-field>

      <mat-form-field appearance="outline" class="regular-form-field" *ngIf="formField.fieldType === 'date'">
        <mat-label>
          {{formField.fieldLabel}}
        </mat-label>

        <input matInput type="text" [id]="formField.fieldName" name="{{formField.fieldName}}"
               [(ngModel)]="formModel[formField.fieldName]" (ngModelChange)="modelChanged($event)"
               [matDatepicker]="datePicker">

        <mat-hint>MM/DD/YYYY</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="datePicker"></mat-datepicker-toggle>
        <mat-datepicker #datePicker></mat-datepicker>
      </mat-form-field>

      <div class="regular-form-field" style="text-align: left" *ngIf="formField.fieldType === 'checkbox'">
        <mat-checkbox type="checkbox" [id]="formField.fieldName" name="{{formField.fieldName}}"
               [(ngModel)]="formModel[formField.fieldName]" (ngModelChange)="modelChanged($event)">{{formField.fieldLabel}}</mat-checkbox>
      </div>
    </div>
  `,
    providers: [
        { provide: DateAdapter, useClass: NativeDateAdapter },
    ],
    styles: [],
    standalone: true,
    imports: [NgFor, NgIf, MatFormField, MatFormFieldFix, MatLabel, MatInput, FormsModule, MatDatepickerInput, MatHint, MatDatepickerToggle, MatSuffix, MatDatepicker, MatCheckbox]
})
export class DynamicFormComponent implements OnChanges, OnInit {

  @Input() formModel: any = {};
  @Input() formModelDescription: FieldDescription[] = [];

  @Output() formChanged = new EventEmitter<any>();

  ngOnChanges(changes: SimpleChanges): void {
    console.log('DynamicFormComponent on change', changes);
  }

  ngOnInit() {
    // console.log(this.optionsMap);
  }

  modelChanged($event: any) {
    this.formChanged.emit(this.formModel);
  }
}
